import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { UserResolverService } from '@mediahaven/shared';
import { ShPreloadingStrategyService } from '@stylehaven/components';
import { LocaleResolverService } from './resolvers/locale.resolver.service';

const routes: Routes = [
    {
        path: 'viewer',
        loadChildren: () => import('@stylehaven/components').then(module => module.ViewerModule)
    },
    {
        path: '',
        resolve: {
            LocaleResolverService: LocaleResolverService,
            UserResolverService
        },
        loadChildren: () => import('@app/application.module').then(m => m.ApplicationModule)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload',
    enableTracing: false,
    preloadingStrategy: ShPreloadingStrategyService,
    paramsInheritanceStrategy: 'always'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerConfig)],
    exports: [RouterModule]
})
export class BootstrapRoutingModule {}
